module.exports = __webpack_public_path__ + "static/media/Super Warrior.1cdb65cf.jpg";